import { animationDurationFast03 } from '@fiverr-private/sass/helpers/index';

/**
 * Amount of milliseconds to wait.
 * @type {Number}
 */
export const DELAY_MS = animationDurationFast03;
